import { css as m, LitElement as v, html as l } from "lit";
import { property as c, customElement as d } from "lit/decorators.js";
import { classMap as f } from "lit/directives/class-map.js";
import { b as h } from "./styles-scZ6dVz-.js";
var b = Object.defineProperty, u = Object.getOwnPropertyDescriptor, o = (s, n, t, i) => {
  for (var r = i > 1 ? void 0 : i ? u(n, t) : n, p = s.length - 1, a; p >= 0; p--)
    (a = s[p]) && (r = (i ? a(n, t, r) : a(r)) || r);
  return i && r && b(n, t, r), r;
};
let e = class extends v {
  constructor() {
    super(...arguments), this.size = "md";
  }
  render() {
    const s = {
      spinner: !0,
      [this.size]: !0
    };
    return l`
      <div class="spinner-container" role="status" aria-live="polite">
        <span part="spinner" class=${f(s)}></span>
        ${this.label ? l`<span class="label">${this.label}</span>` : l`<span class="sr-only">Loading...</span>`}
      </div>
    `;
  }
};
e.styles = [
  h,
  m`
      :host {
        display: inline-flex;
        align-items: center;
        justify-content: center;
      }

      .spinner-container {
        display: inline-flex;
        align-items: center;
        gap: var(--r5-space-2);
      }

      .spinner {
        display: inline-block;
        width: var(--r5-spinner-size);
        height: var(--r5-spinner-size);
        border-radius: 50%;
        border: var(--r5-spinner-thickness) solid var(--r5-spinner-track-color, var(--r5-border));
        border-top-color: var(--r5-spinner-color, var(--r5-color-primary-600));
        animation: ark-spin var(--r5-spinner-speed, 0.75s) linear infinite;
      }

      /* Sizes */
      .xs {
        --r5-spinner-size: 0.75rem;
        --r5-spinner-thickness: 2px;
      }

      .sm {
        --r5-spinner-size: 1rem;
        --r5-spinner-thickness: 2px;
      }

      .md {
        --r5-spinner-size: 1.5rem;
        --r5-spinner-thickness: 2px;
      }

      .lg {
        --r5-spinner-size: 2rem;
        --r5-spinner-thickness: 3px;
      }

      .xl {
        --r5-spinner-size: 3rem;
        --r5-spinner-thickness: 4px;
      }

      /* Label */
      .label {
        color: var(--r5-text-muted);
        font-size: var(--r5-text-sm);
      }

      @keyframes ark-spin {
        to {
          transform: rotate(360deg);
        }
      }
    `
];
o([
  c({ type: String, reflect: !0 })
], e.prototype, "size", 2);
o([
  c({ type: String })
], e.prototype, "label", 2);
e = o([
  d("ark-spinner")
], e);
export {
  e as A
};
//# sourceMappingURL=ark-spinner-CkcDoCJo.js.map
